var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"expand-btn",attrs:{"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('BaseIconText',{attrs:{"icon-url":_vm.icon}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }